import { useCallback, useEffect, useMemo, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    getShareTargetsRequest,
    shareVendorDocumentRequest,
} from "../../../redux/vendor/documents/action";

export const SHARE_WITH_VENDOR_USER = "VendorUser";

export const useDocumentShare = (listQuery) => {
    const dispatch = useDispatch();

    const shareWith = useSelector((state) => state.VendorDocuments?.shareWith || "");
    const shareUsers = useSelector((state) => state.VendorDocuments?.shareUsers);
    const sharedWith = useSelector((state) => state.VendorDocuments?.shareSelected);
    const targetsLoading = useSelector(
        (state) => state.VendorDocuments?.shareTargetsLoading || false
    );
    const sharing = useSelector((state) => state.VendorDocuments?.sharing || false);
    const shareResult = useSelector((state) => state.VendorDocuments?.shareResult);

    const loadTargets = useCallback(
        ({ documentId } = {}) => {
            dispatch(getShareTargetsRequest({ documentId: documentId }));
        },
        [dispatch]
    );

    const targets = useMemo(
        () => ({
            shareWith: shareWith,
            users: shareUsers || [],
            sharedWith: sharedWith || [],
            loading: targetsLoading,
        }),
        [shareWith, shareUsers, sharedWith, targetsLoading]
    );

    const pending = useRef(null);

    useEffect(() => {
        if (!pending.current || !shareResult?.at) return;
        if (shareResult.at < pending.current.at) return;
        const resolve = pending.current.resolve;
        pending.current = null;
        resolve({ status: !!shareResult.status, message: shareResult.message });
    }, [shareResult]);

    const share = useCallback(
        ({ documentId, allVendors, vendorIds, userIds }) => {
            const answered = new Promise((resolve) => {
                pending.current = { at: Date.now(), resolve: resolve };
            });

            dispatch(
                shareVendorDocumentRequest({
                    documentId: documentId,
                    allVendors: !!allVendors,
                    vendorIds: vendorIds || [],
                    userIds: userIds || [],
                    listQuery: listQuery || {},
                })
            );

            return answered;
        },
        [dispatch, listQuery]
    );

    return { targets, loadTargets, share, sharing };
};
